<template>
  <v-dialog
    v-model="display"
    max-width="500"
    content-class="rounded-xl elevation-0"
    @keydown.enter="display = false"
    :persistent="persistent"
    :fullscreen="fullscreen"
    :transition="fullscreen ? 'scroll-y-reverse-transition' : 'scale-transition'"
  >
    <v-card elevation="0" rounded="lg" class="app-sunset-help-modal-card">
      <div class="app-sunset-help-modal-content">
        <div class="app-sunset-help-modal-close-container">
          <v-icon color="#828282" size="24" @click="display = false">
            mdi-close
          </v-icon>
        </div>

        <div class="app-sunset-help-modal-container">
          <h3 class="app-sunset-help-modal-title">
            Ayuda
          </h3>

          <div class="app-sunset-help-modal-text">
            Si tienes dudas o necesitas ayuda con la migracion desde Mi DVA a
            Nauta, puedes escribirnos por Whatsapp o ir al centro de ayuda web.
          </div>

          <div class="app-sunset-help-modal-button-row">
            <div class="app-sunset-help-modal-help-center-button">
              <NewButton
                text="Ir al centro de ayuda"
                icon="mdi-face-agent"
                link="https://ayuda.dvacapital.com/es/es/collections/17267829-migracion-desde-mi-dva-a-nauta"
              />
            </div>
            <div class="app-sunset-help-modal-chat-with-us-button">
              <NewButton
                text="Chatear por Whatsapp"
                link="https://wa.me/+56982128541?text=Hola,%20necesito%20ayuda%20para%20migrarme%20a%20Nauta."
                icon="mdi-whatsapp"
              />
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import NewButton from "@/components/shared/NewButton.vue";

export default {
  name: "AppSunsetHelpModal",

  components: { NewButton },

  props: {
    value: Boolean,
    fullscreen: Boolean,
    persistent: Boolean,
  },

  computed: {
    display: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("display", value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.app-sunset-help-modal-card {
  border: 1px solid #e2e0e0;
  border-radius: 40px !important;
  background: #f2f2f2;
}

.app-sunset-help-modal-content {
  height: 100%;
  padding: 24px;

  @media (max-width: 600px) {
    padding: 24px;
  }
}

.app-sunset-help-modal-close-container {
  display: flex;
  justify-content: flex-end;
}

.app-sunset-help-modal-container {
  margin-top: 4px;
}

.app-sunset-help-modal-title {
  margin: 0;
  color: #333333;
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.56px;
}

.app-sunset-help-modal-text {
  margin-top: 16px;
  color: #646363;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 160%;
}

.app-sunset-help-modal-button-row {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.app-sunset-help-modal-help-center-button ::v-deep .new-btn,
.app-sunset-help-modal-chat-with-us-button ::v-deep .new-btn {
  height: 60px !important;
  border-radius: 10px !important;
}

.app-sunset-help-modal-chat-with-us-button ::v-deep .new-btn {
  background-color: #0b5934 !important;
}
</style>
